// import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';
import {
  AudioConfig,
  SpeechConfig,
  SpeechRecognitionResult,
  SpeechRecognizer,
} from 'microsoft-cognitiveservices-speech-sdk'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

interface GetTextFromSpeech {
  onSpeechStart?: () => any
  onSpeechEnd?: () => any
}

const AZURE_SUBSCRIPTION_KEY = getEnv(Env.AzureSubscriptionKey)
const AZURE_SERVICE_REGION = getEnv(Env.AzureServiceRegion)

export default class AzureSpeechService {
  public speechConfig: SpeechConfig
  public audioConfig: AudioConfig
  public recognizer: SpeechRecognizer

  constructor() {
    this.audioConfig = AudioConfig.fromDefaultMicrophoneInput()
    this.speechConfig = SpeechConfig.fromSubscription(AZURE_SUBSCRIPTION_KEY, AZURE_SERVICE_REGION)
    this.speechConfig.speechRecognitionLanguage = 'en-GB'
    this.recognizer = new SpeechRecognizer(this.speechConfig, this.audioConfig)
  }

  public getTextFromSpeech(callbacks: GetTextFromSpeech = {}): Promise<SpeechRecognitionResult> {
    const { onSpeechEnd, onSpeechStart } = callbacks

    return new Promise((resolve, reject) => {
      if (onSpeechStart) {
        this.recognizer.speechStartDetected = onSpeechStart
      }
      if (onSpeechEnd) {
        this.recognizer.speechEndDetected = onSpeechEnd
      }
      this.recognizer.recognizeOnceAsync(
        (result) => resolve(result),
        (err) => reject(err),
      )
    })
  }

  public continousSpeech(onEnd: () => void, onUpdate: (text: string) => void, onErr: (err: string) => void) {
    this.recognizer.recognized = (_a, ev) => {
      onUpdate(ev.result.text)
    }
    this.recognizer.startContinuousRecognitionAsync(onEnd, onErr)

    return this.recognizer.stopContinuousRecognitionAsync.bind(this.recognizer)
  }
}
